// extracted by mini-css-extract-plugin
export default {"branchPickerContainer":"BranchPicker-module__branchPickerContainer--_N8dW"};